import { ReactComponent as QQMusicColorLight } from 'fym-shared/src/music-services/assets/images/qq-color-light.svg';
import { ReactComponent as QQMusicColorDark } from 'fym-shared/src/music-services/assets/images/qq-color-dark.svg';
import { ReactComponent as QQMusicColorLightPadding } from 'fym-shared/src/music-services/assets/images/qq-color-light-padding.svg';
import { ReactComponent as QQMusicColorDarkPadding } from 'fym-shared/src/music-services/assets/images/qq-color-dark-padding.svg';
import { MusicServiceImages } from './types';

export const qqMusicImages: MusicServiceImages = {
  logoColor: {
    light: QQMusicColorLight,
    dark: QQMusicColorDark,
  },
  logoColorPadding: {
    light: QQMusicColorLightPadding,
    dark: QQMusicColorDarkPadding,
  },
};
